import ApiService from '@/core/services/api.service';
import { cmdUrl } from '@/utils/apiUrl';

const buildUrl = (template, params) =>
  Object.entries(params).reduce((url, [k, v]) => url.replace(`{${k}}`, v), template);

export default {
  async getShippingInfo(orderId) {
    const response = await ApiService.query(buildUrl(cmdUrl.ShippingUrl.info, { id: orderId }));
    return response.data.data;
  },

  async getAvailableServices(orderId, params) {
    const response = await ApiService.query(buildUrl(cmdUrl.ShippingUrl.services, { id: orderId }), {
      params,
    });
    return response.data.data;
  },

  async createShipping(orderId, payload) {
    const response = await ApiService.post(buildUrl(cmdUrl.ShippingUrl.create, { id: orderId }), payload);
    return response.data.data;
  },

  async cancelShipping(orderId) {
    const response = await ApiService.delete(buildUrl(cmdUrl.ShippingUrl.cancel, { id: orderId }));
    return response.data.data;
  },

  async getPrintLabel(orderId, labelType = '1') {
    const response = await ApiService.query(buildUrl(cmdUrl.ShippingUrl.printLabel, { id: orderId }), {
      params: { labelType },
    });
    return response.data.data;
  },

  async getCarriers(companyId = null) {
    const params = companyId ? { companyId } : {};
    const response = await ApiService.query(cmdUrl.ShippingUrl.carriers, { params });
    return response.data.data;
  },

  async upsertCarrier(payload) {
    const response = await ApiService.post(cmdUrl.ShippingUrl.carriers, payload);
    return response.data.data;
  },

  async updateCarrier(id, payload) {
    const response = await ApiService.put(buildUrl(cmdUrl.ShippingUrl.carrierById, { id }), payload);
    return response.data.data;
  },

  async testCarrierConnection(id) {
    const response = await ApiService.post(buildUrl(cmdUrl.ShippingUrl.carrierTest, { id }));
    return response.data.data;
  },

  async testCarrierConnectionWithCredentials(payload) {
    const response = await ApiService.post(cmdUrl.ShippingUrl.carrierTestWithCredentials, payload);
    return response.data.data;
  },

  async getVtpProvinces() {
    const response = await ApiService.query(cmdUrl.ShippingUrl.vtpProvinces);
    return response.data.data;
  },

  async getVtpWards(provinceId) {
    const response = await ApiService.query(cmdUrl.ShippingUrl.vtpWards, { params: { provinceId } });
    return response.data.data;
  },

  async getNtProvinces() {
    const response = await ApiService.query(cmdUrl.ShippingUrl.ntProvinces);
    return response.data.data;
  },

  async getNtDistricts(provinceId) {
    const response = await ApiService.query(cmdUrl.ShippingUrl.ntDistricts, { params: { province_id: provinceId } });
    return response.data.data;
  },

  async getNtWards(provinceId) {
    const response = await ApiService.query(cmdUrl.ShippingUrl.ntWards, { params: { province_id: provinceId } });
    return response.data.data;
  },

  async getSenderAddresses(params = {}) {
    const response = await ApiService.query(cmdUrl.ShippingUrl.senderAddresses, { params });
    return response.data.data;
  },

  async createSenderAddress(payload) {
    const response = await ApiService.post(cmdUrl.ShippingUrl.senderAddresses, payload);
    return response.data.data;
  },

  async updateSenderAddress(id, payload) {
    const response = await ApiService.put(buildUrl(cmdUrl.ShippingUrl.senderAddressById, { id }), payload);
    return response.data.data;
  },

  async deleteSenderAddress(id) {
    const response = await ApiService.delete(buildUrl(cmdUrl.ShippingUrl.senderAddressById, { id }));
    return response.data.data;
  },
};
